import React from 'react';

import LoginForm from './LoginForm';

export default function AdminLogin() {
  return <LoginForm isAdmin />;
}
